module.exports = __webpack_public_path__ + "img/09_bohle.56207f83.jpeg";